import { call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  addNewAccountAdminDone,
  addNewAccountAdminError,
  addNewAccountAdminLoading,
  addNewAccountAdminSuccess,
  fetchAccountAdminDone,
  fetchAccountAdminError,
  fetchAccountAdminLoading,
  fetchAccountAdminSuccess,
  removeAccountAdminDone,
  removeAccountAdminError,
  removeAccountAdminLoading,
  removeAccountAdminSuccess
} from '../actions/accountAdmins';
import { adminApi } from '../api/AdminApi';
import {
  ADD_NEW_ACCOUNT_ADMIN,
  FETCH_ACCOUNT_ADMIN,
  REMOVE_ACCOUNT_ADMIN
} from '../actions/actionTypes';

export function* watchFetchAccountAdminsSaga () {
  yield takeLatest(FETCH_ACCOUNT_ADMIN, fetchAccountAdminsSaga);
}

export function* fetchAccountAdminsSaga ({ tenantId }) {
  try {
    yield put(fetchAccountAdminLoading());
    const adminList = yield call(adminApi.listTenantAdmins, tenantId);
    yield put(fetchAccountAdminSuccess(adminList));
  } catch (error) {
    yield put(fetchAccountAdminError(error));
  } finally {
    yield put(fetchAccountAdminDone());
  }
}

export function* watchAddNewAccountAdminsSaga () {
  yield takeLatest(ADD_NEW_ACCOUNT_ADMIN, addNewAccountAdminsSaga);
}

export function* addNewAccountAdminsSaga ({ tenantId, emails }) {
  try {
    yield put(addNewAccountAdminLoading());
    const adminList = yield call(adminApi.addNewAdmins, tenantId, emails);
    yield put(addNewAccountAdminSuccess(adminList));
  } catch (error) {
    yield put(addNewAccountAdminError(error));
  } finally {
    yield put(addNewAccountAdminDone());
  }
}

export function* watchRemoveAccountAdminsSaga () {
  yield takeLatest(REMOVE_ACCOUNT_ADMIN, removeAccountAdminsSaga);
}

export function* removeAccountAdminsSaga ({ tenantId, idOrEmail }) {
  try {
    yield put(removeAccountAdminLoading());
    const adminList = yield call(adminApi.removeAdmin, tenantId, idOrEmail);
    yield put(removeAccountAdminSuccess(adminList));
  } catch (error) {
    yield put(removeAccountAdminError(error));
  } finally {
    yield put(removeAccountAdminDone());
  }
}

export default [
  fork(watchFetchAccountAdminsSaga),
  fork(watchAddNewAccountAdminsSaga),
  fork(watchRemoveAccountAdminsSaga)
];
